import {MenuItem} from "@/models/Menu/MenuItem";

export class MenuListRepository {
    static toEntity(routeNative) {
        let menuItem = new MenuItem(
            routeNative.id,
            routeNative.version,
            routeNative.force_url,
            routeNative.route,
            routeNative.text,
            "",
            routeNative.icon
        );
        menuItem.order = routeNative.order;
        if(routeNative.children) {
            routeNative.children.forEach((child) => { menuItem.addChildren(this.toEntity(child)); })
        }

        if(routeNative.permissions) {
            routeNative.permissions.forEach(permission => { menuItem.addPermission(permission)})
        }
        return menuItem;
    }
}
